import { render } from "./EditMenuItem.vue?vue&type=template&id=41244628"
import script from "./EditMenuItem.vue?vue&type=script&lang=js"
export * from "./EditMenuItem.vue?vue&type=script&lang=js"

import "./EditMenuItem.vue?vue&type=style&index=0&id=41244628&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__